export const idbConfig = {
  dbStoreName: "bmcms_cache",
  objectStoreName: "bmcms",
};
